import React, { Component, Fragment } from "react";
import moment from "moment";
import ReactHtmlParser from 'react-html-parser';
//services
import { UtilityService } from "../../../services";
import { array } from "prop-types";

class PrintGarmentTech extends Component {
  state = {
    printGarmentTech: {}
  };

  componentWillMount() {
    this.setState({
      printGarmentTech: this.props.printGarmentTech
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.printGarmentTech != this.props.printGarmentTech) {
      this.setState({
        printGarmentTech: nextProps.printGarmentTech
      });
    }
  }

  commentsHead = (data) => {
    switch (data) {
      case 'fitMesurements':
        return "FIT / MEASUREMENTS"
        break;
      case 'makeupConstruction':
        return "MAKE UP / CONSTRUCTION"
        break;
      case 'trimsComponents':
        return "TRIMS / COMPONENTS"
        break;
      case 'packPresentation':
        return "PACKAGING / PRESENTATION"
        break;

    }
  }

  render() {
    const { printGarmentTech } = this.state;
    console.log(printGarmentTech.sampleForm);

    return (
      <Fragment>
        <div className="fabricPrintDiv">
          <style>
            {`@media print {
              body{
                  font-family: 'Montserrat', sans-serif;
                  font-size:12px;
                  padding:10px auto;
              }
              .fabricPrintDiv{
                padding: 10px
                border : 2px solid black;
                top : 0;
                bottom : 0;
              }

              .printrow {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                width: 100%;                
              }

              .printcolumn {
                display: flex;
                flex-direction: column;
                flex-basis: 100%;
                flex: 1;
              }
              table>tbody>tr td{
                  font-size:12px;
              }
              .label-text{
                  color:#279588;
                  font-size : 12px;
                  font-weight:bold;
              }
              .blue{
                  color : #146FF9!important;
              }
              .padding-for-heading{
                padding: 5px;
              }
              .boldItlUnd{
                font-weight:900;
                text-decoration: underline;
                font-style:italic;
              }              

              .specialComments{
                  width: 100% !important;
                  border : 1px solid black;
                  min-height : 60px!important;
                  margin: 5px!important;
                  padding: 10px!important;
              }
              
              // tr, td { 
              //   page-break-before: always;
              //   page-break-after: avoid;
              //   page-break-inside: avoid;
              // }

              // .specialComments, p { 
              //   page-break-before: always!important;
              //   page-break-after: avoid!important;
              //   page-break-inside: avoid!important;
              // }
              
              .b{
                  border: 1px solid black;
                  margin: 10px;
                  padding: 5px;
              }
              .fabric-text{
                font-size:16px;
                color: #279588;
                font-weight: 1000;
              }

              .bold{
                  font-weight:bold;
              }
              .bb-p{
                border-bottom: 1px solid black;
                margin-bottom: 10px ;
              }
              .w-50 {
                  width: 50%;
              }
              table.grid{
                border-collapse: collapse;
                margin-right: 5px;
                margin-left: 5px;
              }
              table.grid>tbody>tr td {
                border: 0.5px solid black;
                padding: 5px;
              }
              .width-for-table{
                  width: 50%;
              }
              .text-center{
                text-align: center;
              }
              .p-1{
                padding : 5px;
              }
              .pl-1{
                padding-left: 23px;
              }
              .border-bot{
                border-bottom : 1px solid black;
              }
              .mt{
                margin-top:10px;
              }
              .mtl{
                margin-top:30px;
              }
              .margin{
                margin : 5px;
              }
              .pl-2{
                padding: 5px;
              }
            }`}
          </style>
          <div className="printrow bb-p">
            <div className="printcolumn">
              {/* <table className="grid">
                <tbody>
                  <tr>
                    <td className="label-text">ASSIGNED TO</td>
                    <td className="label-text">STATUS</td>
                    <td className="label-text">PROCESS COMPL. STATUS</td>
                    <td className="label-text">PROCESS DATE</td>
                  </tr>
                  <tr>
                    <td className="label-text">
                      {printGarmentTech.HEADERS.assignedTo
                        ? printGarmentTech.HEADERS.assignedTo
                        : ""}
                    </td>
                    <td className="label-text">
                      {printGarmentTech.HEADERS.status
                        ? printGarmentTech.HEADERS.status
                        : ""}
                    </td>
                    <td className="label-text">
                      {printGarmentTech.HEADERS.processCompleted
                        ? printGarmentTech.HEADERS.processCompleted
                        : ""}
                    </td>

                    <td className="label-text">
                      {printGarmentTech.HEADERS.processDate
                        ? printGarmentTech.HEADERS.processDate
                        : ""}
                    </td>
                  </tr>
                </tbody>
              </table> */}
              {/* <div className="printrow  text-center padding-for-heading blue"> */}
              <table className="grid">
                <tbody>
                  <tr style={{ width: "100%" }}>
                    <td
                      style={{ width: "100%", fontWeight: "900" }}
                      className="text-center padding-for-heading label-text"
                    >
                      SAMPLE RELEASE FORM
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* </div> */}
              <table className="grid">
                <tbody>
                  <tr>
                    <td style={{ width: "33.3%" }}>
                      <span className="label-text">CUST-DEPT: </span>
                      {printGarmentTech.customerDepartment.custName}-
                      {printGarmentTech.customerDepartment.deptName}
                    </td>
                    <td style={{ width: "33.3%" }}>
                      <span className="label-text">STYLE NO: </span>
                      {printGarmentTech.styleNo.label}
                    </td>
                    <td style={{ width: "33.3%" }}>
                      <span className="label-text">STYLE NAME: </span>
                      {printGarmentTech.styleName}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "33.3%" }}>
                      <span className="label-text">SAMPLE REQUEST DATE: </span>
                      {printGarmentTech.sampleRequestDate}
                    </td>
                    <td style={{ width: "33.3%" }}>
                      <span className="label-text">SAMPLE TYPE: </span>
                      {printGarmentTech.sampleType.label}
                    </td>
                    <td style={{ width: "33.3%" }}>
                      <span className="label-text">SAMPLE DATED: </span>
                      {printGarmentTech.sampleDated}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="grid">
                <tbody>
                  <tr>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "45%" }}
                    >
                      COMMENTS FROM BUYER
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "5%" }}
                    >
                      FAB.
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "5%" }}
                    >
                      TRM
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "5%" }}
                    >
                      WKMN
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "5%" }}
                    >
                      BYC
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "5%" }}
                    >
                      PAT
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "30%" }}
                    >
                      REMARKS
                    </td>
                  </tr>

                  {printGarmentTech.sampleForm &&
                    Object.keys(printGarmentTech.sampleForm).map((data, i) => {
                      return (
                        <Fragment>
                          <tr style={{
                            textAlign: "left!important",
                            fontSize: "18px",
                            fontWeight: "900"
                          }}>
                            <td colSpan="7" className="boldItlUnd label-text" >{this.commentsHead(data)}</td>
                          </tr>
                          {printGarmentTech.sampleForm[data].map((data2, index) => {                            
                            return (
                              <Fragment>
                                <tr>
                                  <td
                                    style={{
                                      textAlign: "left!important",
                                      width: "45%"
                                    }}
                                    >
                                   {/* <div>
                                     <code>
                                   {document.querySelector('#draftContent').value}
                                   </code>
                                   </div> */}
                                    {data2.comments.split("\n").map(comment => {
                                      return <p>{ReactHtmlParser(comment)}</p>;
                                    })}
                                  </td>
                                  <td className="text-center" style={{ width: "5%" }}>
                                    {data2.fab ? (
                                      <span>&#x2714;</span>
                                    ) : (
                                        <span>&#x2716;</span>
                                      )}
                                  </td>
                                  <td className="text-center" style={{ width: "5%" }}>
                                    {data2.trims ? (
                                      <span>&#x2714;</span>
                                    ) : (
                                        <span>&#x2716;</span>
                                      )}
                                  </td>
                                  <td className="text-center" style={{ width: "5%" }}>
                                    {data2.workManShip ? (
                                      <span>&#x2714;</span>
                                    ) : (
                                        <span>&#x2716;</span>
                                      )}
                                  </td>
                                  <td className="text-center" style={{ width: "5%" }}>
                                    {data2.buyerChanges ? (
                                      <span>&#x2714;</span>
                                    ) : (
                                        <span>&#x2716;</span>
                                      )}
                                  </td>
                                  <td className="text-center" style={{ width: "5%" }}>
                                    {data2.pat ? (
                                      <span>&#x2714;</span>
                                    ) : (
                                        <span>&#x2716;</span>
                                      )}
                                  </td>
                                  <td
                                    colSpan="6"
                                    style={{
                                      textAlign: "left!important",
                                      width: "30%"
                                    }}
                                  >

                                    {data2.remarks.split("\n").map(comment => {
                                      return <p>{comment}</p>;
                                    })}
                                  </td>
                                </tr>
                              </Fragment>
                            );
                          })}
                        </Fragment>
                      )
                    })}
                </tbody>
              </table>
              <table className="grid">
                <tbody>
                  <tr style={{ width: "100%" }}>
                    <td
                      style={{ width: "100%" }}
                      className="text-center padding-for-heading boldItlUnd label-text"
                    >
                      GARMENT TECH COMMENTS
                    </td>
                  </tr>
                  {/* <tr style={{ width: "100%", minHeight: "60px !important" }}>
                    <td
                      style={{ width: "100%", minHeight: "60px !important" }}
                      className="specialComments"
                    >
                      {printGarmentTech.garmentTechComments &&
                        printGarmentTech.garmentTechComments
                          .split("\n")
                          .map(comment => {
                            return <p>{comment}</p>;
                          })}
                    </td>
                  </tr> */}
                </tbody>
              </table>
              <div className="printrow">
                <div className="specialComments">
                  {printGarmentTech.garmentTechComments &&
                    printGarmentTech.garmentTechComments
                      .split("\n")
                      .map(comment => {
                        return <p>{comment}</p>;
                      })}
                </div>
              </div>
              <table className="grid">
                <tbody>
                  <tr>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "20%" }}
                    >
                      MARKER REQ
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "20%" }}
                    >
                      SMV AMMEND
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "20%" }}
                    >
                      Technical Issues
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "20%" }}
                    >
                      TRAIL REQ
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "20%" }}
                    >
                      MOCK
                    </td>
                  </tr>
                  <tr>
                    <td className="text-center" style={{ width: "20%" }}>
                      {printGarmentTech.markerRequirements &&
                        printGarmentTech.markerRequirements ? (
                          <span>&#x2714;</span>
                        ) : (
                          <span>&#x2716;</span>
                        )}
                    </td>
                    <td className="text-center" style={{ width: "20%" }}>
                      {printGarmentTech.smvAmmendment &&
                        printGarmentTech.smvAmmendment ? (
                          <span>&#x2714;</span>
                        ) : (
                          <span>&#x2716;</span>
                        )}
                    </td>
                    <td className="text-center" style={{ width: "20%" }}>
                      {printGarmentTech.tiIssues &&
                        printGarmentTech.tiIssues ? (
                          <span>&#x2714;</span>
                        ) : (
                          <span>&#x2716;</span>
                        )}
                    </td>
                    <td className="text-center" style={{ width: "20%" }}>
                      {printGarmentTech.trailRequired &&
                        printGarmentTech.trailRequired ? (
                          <span>&#x2714;</span>
                        ) : (
                          <span>&#x2716;</span>
                        )}
                    </td>
                    <td className="text-center" style={{ width: "20%" }}>
                      {printGarmentTech.mock && printGarmentTech.mock ? (
                        <span>&#x2714;</span>
                      ) : (
                          <span>&#x2716;</span>
                        )}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div></div>
              <table className="grid">
                <tbody>
                  <tr>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "33.3%" }}
                    >
                      MERCHANDISER
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "33.3%" }}
                    >
                      GMT TECH
                    </td>
                    <td
                      className="label-text text-center boldItlUnd"
                      style={{ width: "33.3%" }}
                    >
                      PATTERN MASTER
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "33.3%", height: "25px" }}>
                      {printGarmentTech.customerDepartment.merchandiser && Object.keys(printGarmentTech.customerDepartment.merchandiser).length > 0 && `${printGarmentTech.customerDepartment.merchandiser.firstName || ""} ${printGarmentTech.customerDepartment.merchandiser.lastName}`}
                    </td>
                    <td style={{ width: "33.3%", height: "25px" }}>
                      {/* {printGarmentTech.gmtTech} */}
                    </td>
                    <td style={{ width: "33.3%", height: "25px" }}>
                      {/* {printGarmentTech.patternMaster} */}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="grid">
                <tbody>
                  <tr style={{ width: "100%" }}>
                    <td
                      style={{ width: "100%" }}
                      className="text-center padding-for-heading label-text boldItlUnd"
                    >
                      COMMENTS
                    </td>
                  </tr>
                  {/* <tr style={{ width: "100%", minHeight: "60px !important" }}>
                    <td
                      style={{ width: "100%", minHeight: "60px !important" }}
                      className="specialComments"
                    >
                      {printGarmentTech.comment &&
                        printGarmentTech.comment.split("\n").map(comment => {
                          return <p>{comment}</p>;
                        })}
                    </td>
                  </tr> */}
                </tbody>
              </table>
              <div className="printrow">
                <div className="specialComments ">
                  {printGarmentTech.comment &&
                    printGarmentTech.comment.split("\n").map(comment => {
                      return <p>{comment}</p>;
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment >
    );
  }
}

export default PrintGarmentTech;


// WEBPACK FOOTER //
// ./src/components/SampleRequest/GarmentTechModule/PrintGarmentTech.js